/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { TClientId } from '@/main/pages/PageAccountInfo/types';
import type { IOptionItemProps } from '@components/common/Select/Select';

import { EEdmDeliveryInfoFields } from './constants';

export type TEdmOperatorId = number & { readonly brand: unique symbol };
export function EdmOperatorId(id: number) {
	return id as TEdmOperatorId;
}

export type TEdmConnectionId = number & { readonly brand: unique symbol };
export function EdmConnectionId(id: number) {
	return id as TEdmConnectionId;
}

interface IOperatorResponsibleContact {
	email: string;
	personName: string;
	phoneNumber: string;
}

export interface IEdmOperator {
	edmOperatorId: number;
	isRoaming: boolean;
	name: string;
	operatorResponsibleContact: IOperatorResponsibleContact;
}

export interface IEdmOperatorsResponse {
	operators: IEdmOperator[];
}

export interface IEdmOptionItem extends IOptionItemProps {
	isRoaming?: boolean;
}

export interface IOperatorsOptions {
	initialOption: IEdmOptionItem;
	options: IEdmOptionItem[];
}

export interface IEdmConnectionAddData {
	edmOperatorId: TEdmOperatorId;
	email: string;
	personName: string;
	phoneNumber: string;
}

export interface IEdmConnectionAddRequest {
	bisAccountId: TClientId;
	edmConnectionAddData: Partial<IEdmConnectionAddData>;
}

export interface IEdmConnectionCancelRequest {
	bisAccountId: TClientId;
	edmConnectionId: TEdmConnectionId;
}

export interface IAddEdmConnectionForm {
	[EEdmDeliveryInfoFields.operator]: IEdmOptionItem;
	[EEdmDeliveryInfoFields.name]?: string;
	[EEdmDeliveryInfoFields.phone]?: string;
	[EEdmDeliveryInfoFields.email]?: string;
}

export type TEditEdmResponsibleForm = Omit<IAddEdmConnectionForm, 'operator'>;

export interface IEdmResponsibleUpdateRequest {
	bisAccountId: TClientId;
	data: Partial<Omit<IEdmConnectionAddData, 'edmOperatorId'>>;
	edmConnectionId: TEdmConnectionId;
}
